export default __webpack_public_path__ + "static/media/mpag_Logo.f508768e.f508768e.png";